<div class="car-page">
  <div class="car-panel grp-decorated-panel">

    <div class="car-panel__header grp-panel-header">
      <div class="car-panel__header-left">
        <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="22" height="22"
          style="margin-right: 10px; color: #4f46e5;">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" />
        </svg>
        <span class="grp-title-text">Gestion Instagram</span>
      </div>
    </div>

    <div class="car-panel__body" style="padding: 24px;">

      <ng-template #attente>
        <div class="insta-loader-container">
          <div class="spinner-circle spinner-circle--large"></div>
          <span class="insta-loader-text">Chargement des données...</span>
        </div>
      </ng-template>

      <div *ngIf="enregistrementTerminer; else attente">

        <div class="insta-form-layout">

          <div class="insta-upload-col">
            <div class="insta-upload-zone" (click)="importer()">
              <img *ngIf="File_Content" [src]="File_Content" class="insta-preview-img" alt="Aperçu Instagram" />
              <div *ngIf="!File_Content" class="insta-upload-placeholder">
                <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z" />
                </svg>
                <span>Cliquez pour importer</span>
              </div>
            </div>
            <input id="input_file" type="file" style="display: none" (change)="onChangeImagefile($event)" />
          </div>

          <div class="insta-actions-col">
            <div class="insta-input-group">
              <label class="insta-label">Lien de redirection (URL)</label>
              <input type="url" class="insta-input" name="instagramRedirectionUrl" #FileLien="ngModel"
                [(ngModel)]="File_Lien" placeholder="Ex: https://instagram.com/p/..." />
            </div>

            <div class="insta-button-row">
              <button class="insta-btn insta-btn--success" [disabled]="!enregistrementTerminer || isSaving"
                (click)="ajouter()">
                <span class="spinner-circle" *ngIf="isSaving"></span>
                <span *ngIf="!isSaving">Ajouter</span>
              </button>

              <button class="insta-btn insta-btn--primary" [disabled]="!enregistrementTerminer || isSaving"
                (click)="modifier()">
                <span class="spinner-circle" *ngIf="isSaving"></span>
                <span *ngIf="!isSaving">Modifier</span>
              </button>

              <button class="insta-btn insta-btn--danger" [disabled]="!enregistrementTerminer || isSaving"
                (click)="supprimer()">
                <span class="spinner-circle" *ngIf="isSaving"></span>
                <span *ngIf="!isSaving">Supprimer</span>
              </button>
            </div>
          </div>
        </div>

        <hr class="insta-divider" />

        <div class="insta-section-header">
          <h3>Galerie Instagram</h3>
        </div>

        <div class="insta-gallery-grid">
          <div class="insta-gallery-item" *ngFor="let img of listeImages" (click)="selectImage(img)"
            [class.is-selected]="File_Content === img.File_Content">
            <img [src]="img.File_Content" alt="Instagram Post" />
            <div class="insta-gallery-overlay">
              <span>Sélectionner</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>